/* eslint-disable react/prop-types */
import React, { useCallback } from "react";
import { WithLocale } from "@insightfulscience/i18";
import { createAndRaise } from "@insightfulscience/shared-utils/fn/create-and-raise";
import pipe from "@insightfulscience/shared-utils/fn/pipe";
import { LocaleProvider } from "@insightfulscience/smart-react/i18";
import { usePageData } from "@insightfulscience/smart-react/hocs/DiPageHoC";
import ApplicationError from "@insightfulscience/smart-react/ApplicationError";
import WithConditions from "@insightfulscience/smart-react/hocs/WithConditions";
import NextPageWithServices from "@insightfulscience/smart-react/hocs/NextPageWithServices";
import SequencesPageTemplate from "@src/Plasmids/templates";
import resolvers from "@src/Plasmids/resolvers/sequences-resolvers";
import sgApiConnection from "@src/Plasmids/services/sgApiConnection";
import sgApiClient from "@src/Plasmids/services/sgApiClient";
import SectionTryForFree from "@src/SectionTryForFree";
import { serviceCore } from "@src/Plasmids/services";
import SiteLayout from "@src/SiteLayout";
import { withErrorHandling } from "@src/AppError";
import { publicConfig } from "@src/config";
import resources from "../../../locales/plasmids-sequences-page";

const PlasmidsSequencesPage = () => {
	const siteDomain = publicConfig.STATIC_SITE_DOMAIN;
	const { setSequencesData, sets } = usePageData();
	const { setData, sequences } = setSequencesData;

	const title = setData.plasmidSetName;
	const description = setData.plasmidSetDesc;
	const setID = setData.set;
	const filename = setData.plasmidSetFilename;
	const downloadFile = useCallback(() => {
		const fileAnchor = document.createElement("a");
		document.body.appendChild(fileAnchor);
		fileAnchor.href = `https://${siteDomain}/api/plasmids/download?setID=${setID}`;
		fileAnchor.click();
		document.body.removeChild(fileAnchor);
	}, [siteDomain, setID]);
	return (
		<SiteLayout hero>
			<LocaleProvider resources={resources}>
				<SequencesPageTemplate
					typePage={setID}
					title={title}
					description={description}
					setID={setID}
					filename={filename}
					downloadFile={downloadFile}
					sets={sets}
					sequences={sequences}
				/>
			</LocaleProvider>
			<SectionTryForFree />
		</SiteLayout>
	);
};

PlasmidsSequencesPage.getInitialProps = resolvers;

PlasmidsSequencesPage.services = {
	sgApiConn: ({ sgApiConfig }) => sgApiConnection(global.fetch, sgApiConfig.baseUrl),
	sgApiClient: ({ sgApiConn }) => sgApiClient(sgApiConn),
};

PlasmidsSequencesPage.postConditions = [
	[({ setSequencesData }) => !!setSequencesData, createAndRaise(ApplicationError.NotFound)],
];

export default pipe(
	PlasmidsSequencesPage,
	WithLocale({ resources }),
	WithConditions,
	NextPageWithServices(serviceCore),
	withErrorHandling,
);
